import Container from '@/components/Global/Container';
import styled from '@emotion/styled';
import { rem } from 'polished';
export const CrossSellingContainer = styled(Container)``;

export const CrossSellingWrapper = styled.div`
  padding: ${rem('56px')} 0;
  h3 {
    font-family: 'VodafoneLight';
    margin-bottom: ${rem('40px')};
  }
`;

export const CrossSellingButtonWrapper = styled.div`
  margin-bottom: ${rem('40px')};
  text-align: center;
`;
